"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M11.0072 3.08061C12.497 1.54446 14.95 1.50686 16.4861 2.99663C18.0223 4.4864 18.0599 6.93939 16.5701 8.47554",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M2.41152 11.9424C3.90128 10.4063 6.35428 10.3687 7.89043 11.8584C9.42658 13.3482 9.46418 15.8012 7.97441 17.3374",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M2.41191 11.942C0.922144 13.4782 0.959745 15.9312 2.4959 17.4209C4.03205 18.9107 6.48504 18.8731 7.97481 17.337",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M16.6074 8.43652L7.97554 17.3372M2.41265 11.9422L11.0445 3.0416",
      stroke: "currentColor",
      strokeWidth: "1.2"
    })]
  });
};

exports.default = Icon;